import type { Components, CssVarsTheme } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiButton']
>['styleOverrides'] = {
  root: ({ ownerState, theme }) => ({
    ...{
      transition: '0.2s',
    },
    ...(ownerState.variant === 'outlined' && {
      borderColor: theme.vars.palette.grey[200],
      '&:active': {
        borderColor: theme.vars.palette.grey[200],
      },
    }),
    ...(ownerState.variant === 'outlined' &&
      ownerState.color !== 'inherit' &&
      ownerState.color && {
        borderColor: theme.vars.palette[ownerState.color]?.light,
        '&:link': {
          borderColor: theme.vars.palette[ownerState.color]?.light,
        },
        '&:hover': {
          borderColor: theme.vars.palette[ownerState.color]?.main,
        },
        '&:active': {
          borderColor: theme.vars.palette[ownerState.color]?.light,
        },
      }),
    ...(ownerState.variant === 'contained' &&
      ownerState.color === 'inherit' && {
        backgroundColor: theme.vars.palette.grey[200],
        '&:link': {
          backgroundColor: theme.vars.palette.grey[200],
          boxShadow: theme.shadows[3],
        },
        '&:hover': {
          backgroundColor: theme.vars.palette.grey[300],
          boxShadow: theme.shadows[2],
        },
        '&:active': {
          backgroundColor: theme.vars.palette.grey[200],
          boxShadow: theme.shadows[0],
        },
      }),
    ...(ownerState.variant === 'contained' &&
      ownerState.color !== 'inherit' &&
      ownerState.color && {
        backgroundColor: theme.vars.palette[ownerState.color]?.main,
        '&:link': {
          backgroundColor: theme.vars.palette[ownerState.color]?.main,
          boxShadow: theme.shadows[3],
        },
        '&:hover': {
          backgroundColor: theme.vars.palette[ownerState.color]?.dark,
          boxShadow: theme.shadows[2],
        },
        '&:active': {
          backgroundColor: theme.vars.palette[ownerState.color]?.main,
          boxShadow: theme.shadows[0],
        },
      }),
  }),
};

const MuiButton: Components<CssVarsTheme>['MuiButton'] = {
  styleOverrides,
};

export default MuiButton;
